function formatUsd(value) {
    return `$${Number.isInteger(value) ? value : value.toFixed(2)}`;
}
/**
 * Derives the per-service price shown on the service card from its availability
 * rules. Mirrors {@link computeCommissionRange}: rules are fetched separately
 * from GET /services/:id/calendar/availability, so the list payload itself
 * carries no price.
 */
export function computePriceRange(rules) {
    const prices = rules
        .map((r) => r.total_price)
        .filter((p) => typeof p === 'number' && p > 0);
    if (prices.length === 0)
        return null;
    const min = Math.min(...prices);
    const max = Math.max(...prices);
    const amount = min === max ? formatUsd(min) : `${formatUsd(min)} – ${formatUsd(max)}`;
    const hasHour = rules.some((r) => r.price_type === 'HOUR');
    const hasPerson = rules.some((r) => r.price_type === 'PERSON');
    const priceType = hasHour && !hasPerson ? 'HOUR' : 'PERSON';
    return { amount, priceType, min, max };
}
